//IMPACT REPORT NAV
function isSectionInView(el, nextEl) {

    var scrollTop = $(window)['scrollTop']();

    var elTop = $(el)[0].getBoundingClientRect().top + scrollTop - $('.header').height()
    if ($(nextEl)[0] !== undefined) {
        var elBottom = $(nextEl)[0].getBoundingClientRect().bottom + scrollTop - $('.header').height()
    } else {
        var elBottom = $(el)[0].getBoundingClientRect().bottom + scrollTop - $('.header').height()
    }
    var secondElTop = $('.report-nav')[0].getBoundingClientRect().top

    if ($(window).scrollTop() < (secondElTop)) {
        $('.report-nav a').eq(0).addClass('active')
        $(".report-nav a[href='" + el + "'].active").prevAll().removeClass("active")
        $(".report-nav a[href='" + el + "'].active").nextAll().removeClass("active")
    } else if ((scrollTop > elTop) && (scrollTop < elBottom)) {
        $(".report-nav a[href='" + el + "']").addClass('active')
        $(".report-nav a[href='" + el + "'].active").prevAll().removeClass("active")
        $(".report-nav a[href='" + el + "'].active").nextAll().removeClass("active")
    }

    if (!$('.report-nav a.active').length) {
        $('report-nav a').eq(0).addClass('active')
    }

};
function checkReportSectionInView() {
    if ($('.report-nav').length) {
        $('.report-nav a').each(function (index) {
            var hash = $(this).attr("href")
            if (index !== $('.report-nav a').length - 1) {
                var nextHash = $(this).next().attr("href")
            } else {
                var nextHash = hash
            }
            if ($(hash).length) {
                isSectionInView(hash, nextHash);
            }
        });
    }
}
if ($('.report-nav').length) {
    $('.report-nav a').each(function (index) {
        var hash = $(this).attr("href");
        $(this).on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(hash).offset().top - 10
            })
        })
    });
}

//IMPACT REPORT BADGES
function isBadgeInView(currentBadge, currentBadgeSection, nextBadgeSection) {

    var scrollTop = $(window)['scrollTop']();

    var firstBadgeSectionTop =  $('.impact-report-badge').eq(0).parents("section")[0].getBoundingClientRect().top + scrollTop - $('.header').height() - 400
    var lastBadgeSectionBottom =  $('.impact-report-badge').eq($('.impact-report-badge').length - 1).parents("section")[0].getBoundingClientRect().bottom + scrollTop - $('.header').height()
    // if(currentBadgeSection[0].classList.contains("landing-block-callout-boxes")){
    //     var elTop = currentBadgeSection[0].getBoundingClientRect().top + scrollTop - $('.header').height() - currentBadgeSection.outerHeight(true) + 800
    //     var elBottom = currentBadgeSection[0].getBoundingClientRect().bottom + scrollTop - $('.header').height() - currentBadgeSection.outerHeight(true) + 200
    // } else {
    //     var elTop = currentBadgeSection[0].getBoundingClientRect().top + scrollTop - $('.header').height() - currentBadgeSection.outerHeight(true) + 200
    //     var elBottom = currentBadgeSection[0].getBoundingClientRect().bottom + scrollTop - $('.header').height() - currentBadgeSection.outerHeight(true) - 200
    // }
    var elTop = currentBadgeSection[0].getBoundingClientRect().top + scrollTop - currentBadgeSection.height()
    // console.log(currentBadge)
    if(nextBadgeSection !== undefined){
        var elBottom = nextBadgeSection[0].getBoundingClientRect().bottom + scrollTop - nextBadgeSection.outerHeight(true)
    } else {
        var elBottom = currentBadgeSection[0].getBoundingClientRect().bottom + scrollTop - currentBadgeSection.outerHeight(true)
    }
    // var secondElTop = $('.report-nav')[0].getBoundingClientRect().top

    if ((scrollTop > elTop) && (scrollTop < elBottom)) {
        $('.impact-report-badge').removeClass("active")
        currentBadge.addClass('active')
    } else {
        currentBadge.removeClass("active")
    }

    // if (!$('.report-nav a.active').length) {
    //     $('report-nav a').eq(0).addClass('active')
    // }

};
function checkReportBadgeInView() {
    if ($('.impact-report-badge').length) {
        $('.impact-report-badge').each(function (index) {
            var currentBadge = $(this);
            var currentBadgeSection = $(this).parents("section");
            var nextBadgeSection;
            if($(this)[0].classList.contains("impact-report-badge-communities")){
                nextBadgeSection = currentBadgeSection.parent().next()
            }
            if($(this)[0].classList.contains("impact-report-badge-drive")){
                nextBadgeSection = currentBadgeSection.parent().find(".drive-trigger")
            }
            isBadgeInView(currentBadge, currentBadgeSection, nextBadgeSection);
        });
    }
}

function handleScroll () {
    checkReportSectionInView();
    checkReportBadgeInView()
}


//ACCORDIONS
if($('.accordion').length){
    $('.accordion').each(function(){
      var $trigger = $(this).children('.accordion-trigger');
      $trigger.on('click', function(){
         var image = $trigger.attr("data-image");
         var mainImageEl = $trigger.parents(".grid").find(".main-accordion-image")
         mainImageEl.removeAttr("srcset")
         mainImageEl.attr("src", image)
      })
    })      
  }	 

handleScroll()

$(window).on('scroll', handleScroll)